import { createFileRoute, redirect } from "@tanstack/react-router";

import { UsersPage } from "@/features/users/UsersPage";

export const Route = createFileRoute("/_app/users")({
  beforeLoad: ({ context }) => {
    if (context.info.edition !== "cloud" || !context.me?.permissions.includes("users.manage")) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: UsersPage,
});
